export enum ServiceCategory {
    All = 0,
    PersonLicence = 1,
    CorporateLicence = 2
}
